'use client'

import s from './Timeline.module.sass'
import cn from 'clsx'

import { useRef, useEffect, useState } from 'react'

import type { Timeline as TimelineType } from '../../../../../apps/benmax/src/types/sanity.types'

import ImageSlider from '../../ImageSlider/ImageSlider'

import diamond from '../../../images/diamond'

import { Swiper, SwiperSlide } from 'swiper/react'
import { A11y, Autoplay } from 'swiper/modules'

import 'swiper/css'

export default function Timeline({ title, items }: TimelineType) {
    const sliderRef = useRef<any>(null)
    const [activeIndex, setActiveIndex] = useState(0)

    return (
        <section className={s.Timeline}>
            <div className={cn(s.Cont, 'container')}>
                {title && <h1 dangerouslySetInnerHTML={{ __html: title }} />}
                <div className={s.MainOuter}>
                    <div className={s.Main}>
                        <div className={s.Years}>
                            <Swiper
                                ref={sliderRef}
                                modules={[A11y, Autoplay]}
                                spaceBetween={10}
                                slidesPerView={5}
                                className={s.YearSlider}
                                direction="vertical"
                                watchSlidesProgress
                                centeredSlides={true}
                                onClick={(swiper) => swiper.slideTo(swiper.clickedIndex, 500)}
                                onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                            >
                                {items?.map((item, index) => {
                                    const { year } = item
                                    return (
                                        <SwiperSlide key={index} className={s.YearSlide}>
                                            <div className={cn(s.Year, activeIndex === index && s.Active)}>
                                                {year && (
                                                    <h2
                                                        dangerouslySetInnerHTML={{
                                                            __html: year,
                                                        }}
                                                    />
                                                )}
                                                {diamond}
                                            </div>
                                        </SwiperSlide>
                                    )
                                })}
                            </Swiper>
                        </div>
                        <div className={s.Slider}>
                            {items && (
                                <ImageSlider
                                    breakpoints={{
                                        1024: {
                                            slidesPerView: 1.2,
                                            spaceBetween: 15,
                                        },
                                        1280: {
                                            slidesPerView: 1.5,
                                            spaceBetween: 20,
                                        },
                                    }}
                                    items={items}
                                    showYear
                                    activeIndex={activeIndex}
                                    onSlideChange={(index: number) => {
                                        sliderRef.current?.swiper.slideTo(index, 500)
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
